<template>
  <div class="md-layout">
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">Add user</h4>
        </md-card-header>
        <md-card-content>
          <div class="md-layout">
            <div
              class="md-layout-item md-xsmall-size-100 md-small-size-50 md-medium-size-40 md-size-35 mx-auto"
            >
              <!-- User -->
              <md-field :class="[{ 'md-error': errors.has('USER_NAME') }]">
                <md-icon>perm_identity</md-icon>
                <label>User name</label>
                <md-input
                  v-model="newUser.name"
                  data-vv-name="USER_NAME"
                  type="text"
                  name="USER_NAME"
                  v-validate="modelValidations.login"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('USER_NAME')">close</md-icon>
                </slide-y-down-transition>
              </md-field>

              <!-- Password -->
              <md-field :class="[{ 'md-error': errors.has('USER_PASSWORD') }]">
                <md-icon>vpn_key</md-icon>
                <label>Password</label>
                <md-input
                  v-model="newUser.password"
                  data-vv-name="USER_PASSWORD"
                  type="password"
                  name="USER_PASSWORD"
                  v-validate="modelValidations.password"
                ></md-input>
                <slide-y-down-transition>
                  <md-icon class="error" v-show="errors.has('USER_PASSWORD')">close</md-icon>
                </slide-y-down-transition>
              </md-field>

              <md-button
                class="md-layout-item md-success"
                @click="passwordGenerator"
                v-clipboard:copy="newUser.password"
                v-clipboard:success="copied"
              >Generate password</md-button>

              <md-button class="md-layout-item md-success" @click="addUser">Create new user</md-button>
            </div>
          </div>
        </md-card-content>
      </md-card>
    </div>

    <!-- User list -->
    <div class="md-layout-item md-size-100">
      <md-card>
        <md-card-header class="md-card-header-icon md-card-header-warning">
          <div class="card-icon">
            <md-icon>equalizer</md-icon>
          </div>
          <h4 class="title">Users list</h4>
        </md-card-header>
        <md-card-content>
          <md-table
            :value="queriedData"
            :md-sort.sync="currentSort"
            :md-sort-order.sync="currentSortOrder"
            :md-sort-fn="customSort"
            class="paginated-table table-striped table-hover"
          >
            <md-table-toolbar>
              <md-field>
                <label for="pages">{{$lang.inputs.number_of_rows}}</label>
                <md-select v-model="pagination.perPage" name="pages">
                  <md-option
                    v-for="item in pagination.perPageOptions"
                    :key="item"
                    :label="item"
                    :value="item"
                  >{{ item }}</md-option>
                </md-select>
              </md-field>

              <md-field>
                <label>{{$lang.inputs.search}}</label>
                <md-input
                  type="search"
                  class="mb-2"
                  clearable
                  style="max-width: 200px"
                  placeholder="Search users"
                  v-model="searchQuery"
                ></md-input>
              </md-field>
            </md-table-toolbar>

            <md-table-row slot="md-table-row" slot-scope="{ item }">
              <md-table-cell md-label="Login" md-sort-by="login">{{item.login}}</md-table-cell>
              <md-table-cell md-label="Devices">
                <md-chips v-model="item.devices" class="md-primary" md-static></md-chips>
              </md-table-cell>
              <md-table-cell>
                <md-button
                  class="md-just-icon md-info md-simple"
                  title="Add device"
                  @click="openModal(item)"
                >
                  <md-icon>add_circle</md-icon>
                </md-button>
                <br />
                <md-button
                  class="md-just-icon md-warning md-simple"
                  title="Edit user"
                  style="margin-left: 7px;"
                  @click="openModal2(item)"
                >
                  <md-icon>edit</md-icon>
                </md-button>

                <!-- <md-button class="md-just-icon md-danger md-simple" title="Delete user">
                  <md-icon>close</md-icon>
                </md-button>-->
              </md-table-cell>
            </md-table-row>
          </md-table>
        </md-card-content>

        <md-card-actions md-alignment="space-between">
          <div class>
            <p
              class="card-category"
            >{{$lang.general.showing}} {{ from + 1 }} - {{ to }} {{$lang.general.of}} {{ total }} {{$lang.general.rows}}</p>
          </div>
          <pagination
            class="pagination-no-border pagination-success"
            v-model="pagination.currentPage"
            :per-page="pagination.perPage"
            :total="total"
          ></pagination>
        </md-card-actions>
      </md-card>
    </div>

    <modal v-if="showModal" @close="modalClose">
      <template slot="header">
        <h5 class="modal-title">Device list of user {{modalData.userName}}</h5>
        <md-button class="md-simple md-just-icon md-round modal-default-button" @click="modalClose">
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <md-chip
          v-for="chip in modalData.devices"
          :key="chip"
          md-deletable
          md-clickable
          @md-delete="chipDelete(chip, modalData.devices)"
        >{{chip}}</md-chip>

        <h5 class="title">Add device</h5>
        <div class="md-collapse">
          <div class="md-autocomplete">
            <md-autocomplete
              class="search"
              v-model="modalData.selectedDevice"
              :md-options="modalData.devicesList"
              :md-open-on-focus="true"
              :disabled="modalData.devices.length > 15"
              required
            >
              <label>Device serial number</label>
            </md-autocomplete>
          </div>
        </div>

        <md-field :class="[{ 'md-error': errors.has('VALIDITY') }]">
          <label>Validity</label>
          <md-select
            v-model="modalData.validity"
            :disabled="modalData.devices.length > 15"
            data-vv-name="VALIDITY"
            name="VALIDITY"
            v-validate="modelValidations.required"
            required
          >
            <md-option value="owner">Owner</md-option>
            <md-option value="2592000">1 month</md-option>
            <md-option value="15724800">6 month</md-option>
            <md-option value="31536000">1 year</md-option>
            <md-option value="63072000">2 year</md-option>
          </md-select>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('VALIDITY')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave">{{$lang.keys.save}}</md-button>
        <md-button class="md-simple" @click="modalClose">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <modal v-if="showModal2" @close="modalClose2">
      <template slot="header">
        <h5 class="modal-title">Change password for user {{modalData2.userName}}</h5>
        <md-button
          class="md-simple md-just-icon md-round modal-default-button"
          @click="modalClose2"
        >
          <md-icon>clear</md-icon>
        </md-button>
      </template>

      <template slot="body">
        <!-- Password -->
        <md-field :class="[{ 'md-error': errors.has('USER_NEW_PASSWORD') }]">
          <md-icon>vpn_key</md-icon>
          <label>New password</label>
          <md-input
            v-model="modalData2.newPassword"
            data-vv-name="USER_NEW_PASSWORD"
            type="password"
            name="USER_NEW_PASSWORD"
            v-validate="modelValidations.password"
          ></md-input>
          <slide-y-down-transition>
            <md-icon class="error" v-show="errors.has('USER_NEW_PASSWORD')">close</md-icon>
          </slide-y-down-transition>
        </md-field>
      </template>

      <template slot="footer">
        <md-button class="md-primary" @click="modalSave2">{{$lang.keys.save}}</md-button>
        <md-button class="md-danger" @click="removeUser(modalData2.userName)">{{$lang.keys.delete}}</md-button>
        <md-button class="md-simple" @click="modalClose2">{{$lang.keys.close}}</md-button>
      </template>
    </modal>

    <snack-bar ref="snackbar"></snack-bar>
  </div>
</template>

<script>
import snackBar from "@/components/SnackBar";
import { SlideYDownTransition } from "vue2-transitions";
import { Modal } from "@/components";
import { getUserToken } from "@/storage/memoryStorage";
import axios from "axios";
import { sha256 } from "js-sha256";

import { Pagination } from "@/components";
import Fuse from "fuse.js";

export default {
  components: {
    snackBar,
    SlideYDownTransition,
    Modal,
    Pagination
  },

  data() {
    return {
      modelValidations: {
        required: {
          required: true
        },
        login: {
          required: true,
          min: 3
        },
        password: {
          required: true,
          min: 6
        },
        serial_number: {
          required: true,
          max: 10,
          regex: /^[0-9]+$/
        }
      },
      serial_number: "",
      newUser: {
        name: "",
        password: ""
      },
      usersList: [],
      devicesList: [],
      showModal: false,
      showModal2: false,
      modalData: {
        devices: []
      },
      modalData2: {},

      currentSort: "login",
      currentSortOrder: "desc",
      pagination: {
        perPage: 5,
        currentPage: 1,
        perPageOptions: [5, 10, 25],
        total: 0
      },
      searchQuery: "",
      searchedData: [],
      fuseSearch: null
    };
  },

  computed: {
    queriedData() {
      let result = this.usersList;
      if (this.searchedData.length > 0) {
        result = this.searchedData;
      }
      return result.slice(this.from, this.to);
    },
    to() {
      let highBound = this.from + this.pagination.perPage;
      if (this.total < highBound) {
        highBound = this.total;
      }
      return highBound;
    },
    from() {
      return this.pagination.perPage * (this.pagination.currentPage - 1);
    },
    total() {
      return this.searchedData.length > 0
        ? this.searchedData.length
        : this.usersList.length;
    }
  },

  watch: {
    searchQuery(value) {
      let result = this.usersList;
      if (value !== "") {
        result = this.fuseSearch.search(this.searchQuery);
      }
      this.searchedData = result;
    }
  },

  created() {
    this.getUserList();
    this.getDeviceList();
  },

  methods: {
    modalSave() {
      this.$validator
        .validate("VALIDITY", this.modalData.validity)
        .then(res1 => {
          if (res1) {
            if (this.modalData.selectedDevice && this.modalData.validity) {
              let lifeTime = 0;

              if (this.modalData.validity === "owner") {
                lifeTime = 32535215940;
              } else {
                lifeTime =
                  Math.floor(new Date().getTime() / 1000) +
                  Number(this.modalData.validity);
              }

              axios({
                method: "POST",
                url: this.$ENDPOINTS.API_W + "/applications/usermanager/assign",
                data: {
                  user_token: getUserToken(),
                  login: this.modalData.userName,
                  device: this.modalData.selectedDevice,
                  lifeTime: Number(lifeTime)
                },
                withCredentials: true
              })
                .then(response => {
                  setTimeout(() => {
                    this.getUserList();
                  }, 500);
                })
                .catch(error => {
                  console.log(error);
                });

              this.showModal = false;
            }
          }
        });
    },

    openModal(user) {
      this.modalData.selectedDevice = "";
      this.modalData.userName = user.login;
      this.modalData.devices = user.devices;
      this.modalData.validity = "";

      this.modalData.devicesList = this.devicesList.filter(function(el) {
        return !user.devices.includes(el);
      });

      this.showModal = true;
    },

    modalClose() {
      this.showModal = false;
    },

    modalSave2() {
      axios({
        method: "PUT",
        url: this.$ENDPOINTS.API_W + "/applications/usermanager/user/add",
        data: {
          user_token: getUserToken(),
          login: this.modalData2.userName,
          password: sha256.hex(this.modalData2.newPassword)
        },
        withCredentials: true
      })
        .then(response => {
          this.$validator.reset();
          this.errors.clear();
        })
        .catch(error => {
          console.log(error);
        });

      this.showModal2 = false;
    },

    openModal2(user) {
      this.modalData2.userName = user.login;
      this.modalData2.newPassword = "";

      this.showModal2 = true;
    },

    modalClose2() {
      this.showModal2 = false;
    },

    chipDelete(deviceMAC, devices) {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_W + "/applications/usermanager/assign",
        data: {
          user_token: getUserToken(),
          login: this.modalData.userName,
          device: deviceMAC
        },
        withCredentials: true
      })
        .then(response => {
          const index = this.modalData.devices.indexOf(deviceMAC);
          if (index !== -1) {
            this.modalData.devices.splice(index, 1);
          }
        })
        .catch(error => {
          this.$refs.snackbar.notify("Remove device failed");
        });
    },

    addUser() {
      this.$validator.validate("USER_NAME", this.newUser.name).then(res1 => {
        if (res1) {
          this.$validator
            .validate("USER_PASSWORD", this.newUser.password)
            .then(res2 => {
              if (res2) {
                axios({
                  method: "POST",
                  url:
                    this.$ENDPOINTS.API_W +
                    "/applications/usermanager/user/add",
                  data: {
                    user_token: getUserToken(),
                    login: this.newUser.name,
                    password: sha256.hex(this.newUser.password)
                  },
                  withCredentials: true
                })
                  .then(response => {
                    this.newUser.name = "";
                    this.newUser.password = "";
                    this.$validator.reset();
                    this.errors.clear();

                    setTimeout(() => {
                      this.getUserList();
                    }, 500);
                  })
                  .catch(error => {
                    console.log(error);
                  });
              }
            });
        }
      });
    },

    removeUser(username) {
      axios({
        method: "DELETE",
        url: this.$ENDPOINTS.API_W + "/applications/usermanager/user/remove",
        data: {
          user_token: getUserToken(),
          login: username
        },
        withCredentials: true
      })
        .then(response => {
          this.searchQuery = "";
          setTimeout(() => {
            this.getUserList();
            this.modalClose2();
          }, 500);
        })
        .catch(error => {
          console.log(error);
        });
    },

    getUserList() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applications/usermanager/user/list",
        data: {
          user_token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          this.usersList = response.data.data;

          this.fuseSearch = new Fuse(this.usersList, {
            keys: ["login"],
            threshold: 0.3
          });

          let result = this.usersList;
          if (this.searchQuery !== "") {
            result = this.fuseSearch.search(this.searchQuery);
          }
          this.searchedData = result;
        })
        .catch(error => {
          console.log(error);
        });
    },

    getDeviceList() {
      axios({
        method: "POST",
        url: this.$ENDPOINTS.API_R + "/applications/usermanager/device/list",
        data: {
          user_token: getUserToken()
        },
        withCredentials: true
      })
        .then(response => {
          this.devicesList = response.data.data.map(el => el.MAC);
        })
        .catch(error => {
          console.log(error);
        });
    },

    passwordGenerator() {
      const characters = "a-z,A-Z,0-9";
      let charactersArray = characters.split(",");
      let CharacterSet = "";
      let password = "";

      if (charactersArray.indexOf("a-z") >= 0) {
        CharacterSet += "abcdefghijklmnopqrstuvwxyz";
      }
      if (charactersArray.indexOf("A-Z") >= 0) {
        CharacterSet += "ABCDEFGHIJKLMNOPQRSTUVWXYZ";
      }
      if (charactersArray.indexOf("0-9") >= 0) {
        CharacterSet += "0123456789";
      }

      for (let i = 0; i < 14; i++) {
        password += CharacterSet.charAt(
          Math.floor(Math.random() * CharacterSet.length)
        );
      }
      this.newUser.password = password;
    },

    copied() {
      this.$refs.snackbar.notify(
        "Generated password has been copied to clipboard"
      );
    },

    customSort(value) {
      return value.sort((a, b) => {
        const sortBy = this.currentSort;
        if (this.currentSortOrder === "desc") {
          return a[sortBy].localeCompare(b[sortBy]);
        }
        return b[sortBy].localeCompare(a[sortBy]);
      });
    }
  }
};
</script>

<style scoped>
.modal-mask {
  z-index: 8;
}
.md-chip {
  background-color: #4caf50 !important;
}
</style>